import { Component } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import toast from 'lib/toast'
import api from 'api'
import BusyOverlay from 'components/common/BusyOverlay'
import { messageFromResponseError } from 'utils/strings'

export default class GoogleCallback extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  }

  state = {
    busy: false
  }

  async componentDidMount() {
    const { location, history } = this.props

    const { access_token } = queryString.parse(location.hash)
    const { requested_demo, source_url } = queryString.parse(location.search)

    if (!access_token) return

    await new Promise(resolve => this.setState({ busy: true }, resolve))

    try {
      const { link } = await api.users.freeEdition.getGoogleActivationLink({
        accessToken: access_token,
        requested_demo,
        source_url
      })

      window.location.href = link
    } catch (err) {
      toast({
        type: 'error',
        text: messageFromResponseError(
          err,
          'There was an issue in authentication, please try again.'
        )
      })

      history.push('/signup')
    } finally {
      this.setState({ busy: false })
    }
  }

  render() {
    return <BusyOverlay shown={this.state.busy} />
  }
}
